import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ caption, title, as: Tag = "h2" }) => (
  <Reveal className="mb-12 sm:mb-16">
    <p className="text-xs sm:text-sm tracking-[0.3em] text-brand font-semibold mb-4">{caption}</p>
    <Tag className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold leading-snug text-[#1A1A1E]">{title}</Tag>
    <div className="mt-5 h-px w-24 bg-gradient-to-l from-[#C80000] to-transparent" />
  </Reveal>
);
